function isInSubmissionPage() {
  return $("#submissions-page").length > 0;
}

function isInFormBuilderPage() {
  return $("#embedded-form-builder").length > 0;
}

// reset logout relevant informations
if (window.location.pathname === "/login") {
  window.localStorage.setItem("jTimeOutLoggedOut", 0);
}

function convertToBase64Url(str) {
  // Convert to bytes using UTF-8
  const bytes = new TextEncoder().encode(str); // Uint8Array

  // Convert bytes to a binary string for btoa
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  // Base64 encode, then make URL-safe and strip padding
  const b64 = btoa(binary); //convert binary string into base64-encoded string
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function findLastPageBeforeTimeout() {
  try {
    // Pull pieces from location (works in all browsers)
    const path = window.location.pathname || '/';
    const searchParams = window.location.search || '';
    const hash = window.location.hash || ''; // in case we have any fragment identifier

    // Build the path we want to carry forward after timeout
    const redirectPath = path + searchParams + hash;

    // Build /timeout?... using URL + searchParams (filters) to ensure a safe encoding
    const baseUrl = window.location.origin || (window.location.protocol + '//' + window.location.host);
    const timeoutUrl = new URL('/timeout', baseUrl);

    timeoutUrl.searchParams.set('redirect_uri_b64', convertToBase64Url(redirectPath));
    window.location.assign(timeoutUrl.toString());
  } catch (e) {
    window.location.assign('/timeout');
  }
}


if ($("body").find(".header-my-account").length > 0) {
  require("./timeOutScript");
  var dialogSelector = "#session-expire";
  $("body").append(
    $(
      '<div class="grid-row dialog-wrapper">\
        <dialog th:fragment="session-expire" class="dialog warning-red-border" role="alertdialog" id="session-expire" aria-labelledby="session-expire-label" aria-describedby="session-expire-desc" aria-modal="true" aria-live="assertive" >\
        <div class="notice govuk-red-banner">\
            <h2 id="session-expire-label">Time out warning</h2>\
        </div>\
        <p id="session-expire-desc">Your Delta session is about to time out in <strong><span id="secondsRemaining"></span> seconds</strong>.</p>\
        <div class="button-group">\
        <button class="govuk-button session-continue-button">Continue</button>\
        &nbsp;&nbsp;<a class="govuk-button govuk-button--secondary session-logout-button" href="/logout">Log out</a>\
        </div>\
        </dialog>\
        </div>',
    ),
  );

  function getUserTimeoutInSecondsFromCookie() {
    let userTimeoutInSecondsFromCookie = NaN;
    const cookiesString = "; " + document.cookie;
    const cookiesArray = cookiesString.split("; userTimeoutInSeconds=");
    if (cookiesArray.length === 2) {
      const cookieValue = cookiesArray.pop().split(";").shift();
      userTimeoutInSecondsFromCookie = parseInt(cookieValue);
    }

    if (isNaN(userTimeoutInSecondsFromCookie)) {
      userTimeoutInSecondsFromCookie = 900; // sets timeout to 15 mins in case it hasn't been set correctly
    }
    return userTimeoutInSecondsFromCookie;
  }

  const userTimeoutInSecondsFromCookie = getUserTimeoutInSecondsFromCookie();

  // automatic logout after 60 seconds
  var time = $.jTimeout({
    // key used to store expiration in localstorage (change this for multiple timers)

    expiration_key: "jtimeout-session-expiration",

    // flash the tab/title bar when or after timing out

    flashTitle: false,

    onTimeout: function (jTimeout) {
      let userTimeoutInMinutes = Math.floor(
        userTimeoutInSecondsFromCookie / 60,
      );
      let timeoutMessage =
        "For your security, we have automatically ended your session after " +
        userTimeoutInMinutes +
        " minute" +
        (userTimeoutInMinutes === 1 ? " " : "s ") +
        "of inactivity.";
      localStorage.setItem("timeoutMessage", timeoutMessage);
      //window.location.href = "/timeout";
      findLastPageBeforeTimeout(); //to get last page before time out
    },

    // flash speed in milliseconds

    flashTitleSpeed: 500,

    // text to show in the tab/title bar

    flashingTitleText: "**WARNING**",

    // original page title

    originalTitle: document.title,

    // timeout in seconds
    timeoutAfter: userTimeoutInSecondsFromCookie,

    // seconds in between checking and updating the timer

    heartbeat: 1,

    // extends the session when the mouse is moved
    extendOnMouseMove: true,

    // seconds between extending the session when the mouse is moved

    //    mouseDebounce: 30,

    // on mouse move function
    onMouseMove: function (timeout) {
      if (!$("body").hasClass("dialog-is-open")) {
        timeout.resetExpiration();
      }
    },

    // seconds between extending the session when the mouse is moved

    mouseDebounce: 10,

    logoutUrl: "/logout",
    loginUrl: "/login",
    // seconds before timeout to fire the next callback
    secondsPrior: 60,
    // resets the timer with mouse move while the dialog is visible and hide it
    triggerResetOnAlert: true,

    onClickExtend: function (timeout) {
      /* Request dashboard to increase session */
      if ($("body").hasClass("dialog-is-open")) {
        dialogClose();
      }
      $.get(timeout.options.extendUrl);

      timeout.resetExpiration();
    },

    onSessionExtended: function (timeout) {
      dialogClose();
    },

    onPriorCallback: function (timeout, seconds) {
      if (!$("#session-expire").attr("open")) {
        $("body").addClass("dialog-is-open");
        $(dialogSelector)[0].showModal();
      }
      $(".session-continue-button").click(function (e) {
        extendSession();
        //                timeout.resetExpiration();
        timeout.options.onSessionExtended(timeout);
        //                    $(dialogSelector).trigger('dialog.close');
      });
      $(".session-logout-button").click(function (event) {
        event.preventDefault
          ? event.preventDefault()
          : (event.returnValue = false);
        setToLogout();
      });
    },
  });

  // set the timer counting down in the modal
  var timer;
  var setTimer = function () {
    timer = window.setInterval(function () {
      if (
        $.jTimeout().getSecondsTillExpiration() > 60 &&
        $("body").hasClass("dialog-is-open")
      ) {
        dialogClose();
      }

      if ($.jTimeout().get("jTimeOutLoggedOut") == "1") {
        $.jTimeout().set("jTimeOutLoggedOut", 0);
        toLogout();
      }

      $("#secondsRemaining").html($.jTimeout().getSecondsTillExpiration());
    }, 1000);
  };
  setTimer();

  function dialogClose() {
    if (dialogSelector) {
      var id = $(dialogSelector)[0].id;
      var dialog = document.getElementById(id);
      dialog.close();
      $("body").removeClass("dialog-is-open");
    }
  }

  jQuery("*:not(.nocapture)").on("click", function (e) {
    if (
      $(this).attr("href") &&
      !$(this).attr("data-dialog-reference") &&
      !$(this).attr("data-dialog-target") &&
      !$(this).closest("li").attr("data-dialog-target")
    ) {
      time.resetExpiration();
    }
  });

  module.exports = {
    sessionTimeout: function (response) {
      time.resetExpiration();
    },
  };

  function extendSession() {
    $.ajax({
      dataType: "JSON",
      url: "/authenticated-heartbeat",
      //            data: $("#transactionsReportCommand").serialize()
    })
      .done(function (response) {
        time.resetExpiration();
      })
      .fail(function (response) {
        window.location.assign("/logout");
      });
  }

  function setToLogout() {
    // set a session variable to true/false
    if (window.location.pathname !== "/login") {
      $.jTimeout().set("jTimeOutLoggedOut", 1);
    }

    toLogout();
  }

  function toLogout() {
    window.onbeforeunload = null;
    window.location.href = "/logout";
  }

  if (isInFormBuilderPage()) {
    (function (ns, fetch) {
      if (typeof fetch !== "function") return;

      ns.fetch = function () {
        var out = fetch.apply(this, arguments);

        time.resetExpiration();
        return out;
      };
    })(window, window.fetch);
  }

  if (isInSubmissionPage()) {
    $("form input").change(function () {
      time.resetExpiration();
    });
    $("form select").change(function () {
      time.resetExpiration();
    });
  }
}
